























































































import BaseItemsPage from "../BaseItemsPage";
import { PushSubscriberItem } from "@/store/push/statistic/types";
import { Component } from "vue-property-decorator";
import PushSubscriberCharts from "@/components/Push/Statistic/PushSubscriberCharts.vue";
import PushSubscriberFilter from "@/components/Push/Statistic/PushSubscriberFilter.vue";
import {ScrollButton} from "wings-ui-components";
import { Getter } from "vuex-class";
import { onlyDateFilter } from "@/utils/date-util";
import { dynamicSort } from "@/utils/data-helper";
import {cloneDeep} from "lodash";

@Component({
  components: {PushSubscriberCharts,PushSubscriberFilter, ScrollButton},
  filters: {onlyDateFilter},
})
export default class PushSubscribers extends BaseItemsPage<PushSubscriberItem> {
  @Getter("pushSubscribers") responseItems: any;
  private is_show_graphics = true;
  is_show_filter = true;
  filterClone: any = {};
  runFilter: boolean = false;
  currentSort:string= "date";
  currentSortOrder:string= "asc";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'date', 'android_count', 'ios_count', 'total_count'
    ];
  }

  getData() {
    return this.responseItems;
  }

  get chartsData() {
    return cloneDeep(this.responseItems).sort(dynamicSort('date','asc'));
  }

  setFilter(field: string, value: any) {
    this.filterClone[field] = value;
    this.runFilter = true;
  }
}
